import React, { useContext, useEffect } from 'react';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    ThemeProvider,
    createTheme,
    CssBaseline,
} from '@mui/material';
import {
    Close,
    SettingsApplications,
} from '@mui/icons-material';
import '../../../assets/styles/MerchantDetails.scss';
import '../../../assets/styles/Pricing.scss';
import '../../../assets/styles/CommonForm.scss';
import { CommonContext } from '../../../context';
import VerticalTabs from './VerticalTabs';
import AlertMessage from '../../common/AlertMessage';

const theme = createTheme({
    palette: {
        primary: {
            main: '#004d40',
        },
    },
});

const MerchantDetails = () => {
    const { openAlert, isDetails, detailsToggleDrawer, user, onMerchantDetails, rowData } = useContext(CommonContext);

    useEffect(() => {
        if (rowData) {
            onMerchantDetails(rowData?.id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowData])

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box className="order-details-container">
                <Drawer
                    anchor="right"
                    open={isDetails}
                    onClose={detailsToggleDrawer}
                    className="order-drawer"
                    PaperProps={{
                        className: "drawer-paper"
                    }}
                >
                    <Box className="drawer-content">

                        {/* Header */}
                        <Box className="drawer-header">
                            <Box className="header-left">
                                <SettingsApplications className="header-icon" />
                                <Typography variant="h5" className="header-title">
                                    {user?.user_type === "Merchant" ? "Site Setting" : "Merchant Details"}
                                </Typography>

                            </Box>
                            <Box className="header-actions">
                                <IconButton onClick={detailsToggleDrawer} className="close-button">
                                    <Close />
                                </IconButton>
                            </Box>
                        </Box>

                        <Divider />
                        {openAlert && <AlertMessage />}

                        {/* Content */}
                        <Box className="drawer-body">
                            <VerticalTabs />
                        </Box>
                    </Box>
                </Drawer>
            </Box>
        </ThemeProvider>
    );
};

export default MerchantDetails;